module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"NO_ACTIVE_ACCOUNT":"Invalid password"},"fr":{"NO_ACTIVE_ACCOUNT":"Email ou mot de passe invalide"}}')
  delete Component.options._Ctor
}
